import React, { useEffect, useState } from "react";
import Service from "../../Service/firebase";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const NursePatientInfo = () => {
	const reduxDetails = useSelector((state) => state.personDetails);
	const [details, setDetails] = useState([]);
	const [isLoading, setIsLoading] = useState([]);
	const firebaseData = async () => {
		const res = await Service.getDrugdetails(reduxDetails.patientid);
		if (res === "error") {
			console.log("Error in get person details data");
		} else {
			setDetails(res);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		firebaseData();
	}, []);
	let count = 0;

	return (
		<div>
			<div>
				<Link to="/nurse/patient">
					<i
						className="fa fa-arrow-circle-o-right fa-2x"
						aria-hidden="true"
					></i>
				</Link>
			</div>
			<table className="table table-striped">
				<thead className="thead tablehead">
					<tr>
						<th scope="col">#</th>
						<th scope="col">Time</th>
						<th scope="col">Symptoms</th>
						<th scope="col">Drug Name</th>
						<th scope="col">Instructions</th>
						<th scope="col">Note</th>
						<th scope="col">Strength</th>
					</tr>
				</thead>
				{isLoading ? (
					<i className="fas fa-spinner fa-pulse fa-2x "></i>
				) : details.length === 0 ? (
					<tbody>
						<tr>
							<td>No Patient Info Found</td>
						</tr>
					</tbody>
				) : (
					<tbody className="tablebody">
						{details &&
							details.map((p, index) => {
								count++;
								let date = new Date(p.createdAt.toDate());
								const createdTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
								const createdDate = `${date.getDate()}/${
									date.getMonth() + 1
								}/${date.getFullYear()}`;
								return (
									<tr key={index}>
										<td className="align-middle">{count}</td>
										<td className="align-middle">
											{`${createdDate}`} {""}
											{`${createdTime}`}
										</td>
										<td className="align-middle">{p.symptom}</td>
										<td className="align-middle">{p.drugName}</td>
										<td className="align-middle">{p.instructions}</td>
										<td className="align-middle">{p.note}</td>
										<td className="align-middle">{p.strength.map((r) => r)}</td>
									</tr>
								);
							})}
					</tbody>
				)}
			</table>
		</div>
	);
};
export default NursePatientInfo;
